module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-2-100.bd037ad9.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-2-100.png
// module id = 2553
// module chunks = 11